module.exports = __webpack_public_path__ + "img/wordpoint.fe62bf54.png";